import { all } from 'redux-saga/effects'

import settingSaga from './settingSaga'
import commonLogSaga from './commonLogSaga'
import userSaga from './userSaga'
import notificationSaga from './notificationSaga'
import chiNhanhSaga from './chiNhanhSaga'
import duAnSaga from './duAnSaga'
import heThongSaga from './heThongSaga'
import customerSaga from './customerSaga'
import categorySaga from './categorySaga'
import productSaga from './productSaga'
import orderSaga from './orderSaga'
import invoiceSaga from './invoiceSaga'
import reportSaga from './reportSaga'

export default function* rootSaga() {
  yield all([
    settingSaga(),
    commonLogSaga(),
    userSaga(),
    notificationSaga(),
    chiNhanhSaga(),
    duAnSaga(),
    heThongSaga(),
    customerSaga(),
    categorySaga(),
    productSaga(),
    orderSaga(),
    invoiceSaga(),
    reportSaga(),
  ])
}
